'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserConnecture } from '../../Entities/User/UserConnecture';
import { UserConnectureCollection } from '../../Collections/User/UserConnectureCollection';

export class UserConnectureRepository extends CoreRepository {
  public getUserConnecture(userId: number, options: object = {}) {
    return this.webAPI.getUserConnecture(userId, options).then((response) => {
      const collection = new UserConnectureCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserConnecture();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public addUserConnecture(userId: number, payload: any = {}) {
    return this.webAPI.addUserConnecture(userId, payload).then((response) => {
      const item = new UserConnecture();
      item.hydrate(response);

      return item;
    });
  }

  public deleteUserConnecture(userId: number, id: number) {
    return this.webAPI.deleteUserConnecture(userId, id).then((response) => {
      return response;
    });
  }

  public updateUserConnecture(userId: number, id: number, payload: any = {}) {
    return this.webAPI.updateUserConnecture(userId, id, payload).then((response) => {
      return response;
    });
  }
}
